
const services = [
  {
    id: 1,
    title: 'Medicare / Over 65',
    description: 'Comprehensive Medicare Advantage and supplemental private plans designed specifically for seniors. Get the coverage you deserve with benefits tailored to your healthcare needs.',
    icon: 'ri-heart-pulse-line',
    features: ['Medicare Advantage Plans', 'Supplemental Coverage', 'Prescription Drug Plans', 'Wellness Programs'],
    image: 'https://public.readdy.ai/ai/img_res/fa2e19c40cf8a8de3e884cd44b3fd1f7.jpg'
  },
  {
    id: 2,
    title: 'Under 65',
    description: 'Private individual and family health insurance for those not yet eligible for Medicare. Flexible plans that fit your lifestyle and budget with comprehensive coverage options.',
    icon: 'ri-group-line',
    features: ['Individual Plans', 'Family Coverage', 'Flexible Deductibles', 'Preventive Care'],
    image: 'https://readdy.ai/api/search-image?query=Young%20diverse%20family%20with%20children%20smiling%20together%20in%20a%20bright%20modern%20home%20setting%2C%20healthy%20and%20happy%20lifestyle%2C%20professional%20photography%20with%20clean%20white%20and%20blue%20tones%2C%20warm%20natural%20lighting&width=600&height=400&seq=under65-1&orientation=landscape'
  },
  {
    id: 3,
    title: 'Group Health',
    description: 'Affordable private plan options for small businesses. Attract and retain top talent with competitive health benefits that work for your company and employees.',
    icon: 'ri-building-2-line',
    features: ['Small Business Plans', 'Employee Benefits', 'Cost-Effective Options', 'HR Support'],
    image: 'https://readdy.ai/api/search-image?query=Diverse%20small%20business%20team%20of%20professionals%20collaborating%20in%20a%20modern%20bright%20office%20space%2C%20happy%20employees%20working%20together%2C%20professional%20corporate%20photography%20with%20clean%20white%20and%20teal%20blue%20accents&width=600&height=400&seq=group-1&orientation=landscape'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#2196F3] font-semibold text-sm uppercase tracking-wider">Our Services</span>
          <h3 className="text-3xl md:text-4xl font-bold text-[#0A2647] mt-3 mb-4">
            Insurance Solutions for Everyone
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We offer comprehensive private health insurance options tailored to meet the unique needs 
            of individuals, families, and businesses in Austin, Texas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2647]/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#2196F3] rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h4 className="text-xl font-bold text-[#0A2647] mb-3">{service.title}</h4>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2 text-gray-700">
                      <i className="ri-check-line text-[#2196F3]"></i>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="tel:512-306-6245"
                  className="mt-6 inline-flex items-center gap-2 text-[#2196F3] font-semibold hover:text-[#1976D2] transition-colors cursor-pointer"
                >
                  Get a Quote
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
